export function ComputerIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16">
      <path
        fill="currentColor"
        d="M11.707 1.333H4.273c-1.62 0-2.94 1.32-2.94 2.94V8.74a2.94 2.94 0 002.94 2.94h2.56c.367 0 .667.3.667.667v.646c0 .367-.3.667-.667.667H5.22a.504.504 0 000 1.007h5.567c.273 0 .5-.227.5-.5 0-.274-.227-.5-.5-.5H9.173A.669.669 0 018.507 13v-.646c0-.367.3-.667.666-.667h2.54a2.94 2.94 0 002.94-2.94V4.28a2.956 2.956 0 00-2.946-2.947z"
      ></path>
    </svg>
  );
}
